import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import yuvashree from '../../../../assets/images/Doctorsimages/yuvashreedr.png'
import favicon from "../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const YuvashreeDoc = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Dr. Yuvashree G | Best Homeopathy Doctor in Chennai";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Yuvashree G (BHMS, DNHE, MSc Psychology), a trusted homeopathy doctor in Chennai offering holistic treatment for chronic conditions, lifestyle disorders, and overall wellness. Book your consultation today."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best homeopathy doctor in Chennai, homeopathy doctor in Chennai, female homeopathy doctor in Chennai, holistic homeopathy doctor in Chennai, homeopathy doctor for chronic diseases in Chennai, homeopathy doctor for lifestyle disorders, consultant homeopathy doctor near me, natural treatment doctor in Chennai, homeopathy doctor for stress and mental health, holistic wellness doctor in Chennai"
      );
    }

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalHref = "https://www.h-cura.com/doctors/dr-yuvashree-homeopathy-consultant";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalHref);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalHref);
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');

    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => { img.style.opacity = '1'; });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr.Yuvashree_G_Profile.pdf');
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Yuvashree G</span>
                  <span className="veenadoc-title-credentials">(BHMS, DNHE, MSc Psychology)</span>
                  <span className="veenadoc-title-location">Chennai</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A Consultant Homoeopathy Doctor in Chennai dedicated to providing individualised and holistic care. 
                    With a strong foundation in classical homoeopathy and additional qualifications in nutrition and psychology, 
                    she understands how physical symptoms are connected with emotional wellbeing and lifestyle patterns.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={yuvashree} alt="Dr. Yuvashree G - Best Homeopathy Doctor in Chennai" className="veenadoc-doctor-image" title='Dr. Yuvashree G – Best Homeopathy Doctor in Chennai' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                <div className="veenadoc-article-block">
                  <h2>About Dr. Yuvashree G</h2>
                  <p>
                    Dr. Yuvashree G completed her education at Sri Sairam Homeopathy Medical College and Research Centre. 
                    Her multi-dimensional perspective, combining homeopathy with nutrition and psychology, allows her to 
                    deliver treatments that are not only effective but also sustainable in the long term.
                  </p>
                  <p>
                    Patients searching for a homeopathy doctor in Chennai who focuses on personalised care find Dr. Yuvashree 
                    to be a compassionate and attentive physician who studies each patient’s body constitution and emotional health.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Clinical Journey & Professional Contributions</h2>
                  <p>
                    With 2 years of clinical experience at Vecura Wellness Clinic, Dr. Yuvashree has treated a wide range 
                    of health concerns. She conducts detailed and structured consultations to understand the complete 
                    health journey, including past illnesses and emotional triggers.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS, DNHE, MSc Psychology</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">2 Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy & Holistic Wellness</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Locations:</span>
                      <span className="veenadoc-info-value">Chennai</span>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Personalised and Holistic Care</h2>
                  <p>
                    Dr. Yuvashree strongly believes that no two patients are the same. Instead of following a standard 
                    treatment method, she carefully evaluates lifestyle habits and medical history to help achieve 
                    deeper healing rather than temporary relief.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Managing Chronic & Lifestyle Conditions</h2>
                  <p>
                    She follows a holistic approach in managing conditions such as hormonal imbalances, digestive issues, 
                    and stress-related concerns. By combining homoeopathy with insights from nutrition, she supports 
                    the body’s natural healing ability and enhances overall vitality.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Preventive Care and Lifestyle Awareness</h2>
                  <p>
                    Dr. Yuvashree emphasises the importance of lifestyle modifications and stress management techniques. 
                    This integrated approach ensures that patients not only recover but also maintain long-term wellness 
                    and a better quality of life.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Meeting Patient Needs Online</h2>
                  <p>Her expertise aligns with the most common search queries, including:</p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Best homeopathy doctor in Chennai for chronic diseases</li>
                    <li>Homeopathy doctor for lifestyle disorders</li>
                    <li>Female homeopathy doctor in Chennai</li>
                    <li>Natural treatment doctor in Chennai</li>
                    <li>Homeopathy doctor for stress and mental health</li>
                  </ul>
                </div>

                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Yuvashree G for Complete Wellness</h2>
                  <p>
                    Choosing Dr. Yuvashree G means choosing a doctor who believes in natural healing and personalised care. 
                    Whether dealing with chronic conditions or seeking overall health improvement, patients can rely on 
                    her commitment to guide them towards lasting healing.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To empower patients with healthier lives and renewed confidence through holistic healing.
                  </p>
                </div>
              </div>

              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote style={{ fontSize: '1.2rem' }}>
                      "Healing starts with us"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Yuvashree G's Philosophy</p>
                  </div>
                  <p>
                    She focuses on identifying and treating the root cause of illness rather than simply managing symptoms, 
                    strengthening the body's natural defence system.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Chennai</h4>
                      <p>Primary Practice Location</p>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience natural healing with Dr. Yuvashree's personalized approach.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button className="veenadoc-sidebar-btn-secondary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>💬</span>
                    <span>Get Free Assessment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow />

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download This Doctor profile as PDF
        </button>
      </div>
    </>
  )
}

export default YuvashreeDoc
